import React, { useEffect, useState } from 'react';
import {
  Button,
} from '@material-ui/core';

import Dialog from '../ui/Dialog';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay.component';
import { markTransactionCodeAsRedeemed } from '../../services/transaction.service';

const MarkCodeAsRedeemed = ({ data }) => {
  const { transaction_code_id, program_id, type, status } = data;

  const [state, setState] = useState({
    errorMessage: null,
    openConfirmation: false,
    successMessage: 'Successfully marked code as redeemed!',
    isLoading: false,
  });

  const onMarkAsRedeemed = async () => {
    if (window.confirm('Do you want to mark this code as redeemed?')) {
      try {
        await markTransactionCodeAsRedeemed({
          transaction_code_id,
          connect_program_id: program_id,
        });
      } catch (e) {
        setState(prev => ({
          ...prev,
          errorMessage: e.message
        }));
      } finally {
        setState(prev => ({ ...prev, isLoading: false, openConfirmation: true }));
      }
    }
  };

  const handleClose = () => {
    setState(prev => ({ ...prev, openConfirmation: false }));
    window.location.reload();
  };

  const {
    successMessage,
    isLoading,
    openConfirmation
  } = state;

  if (isLoading) return <LoadingOverlay />;

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        OK
      </Button>
    </>
  );

  return (
    <>
      {
        type === 'free_good' && status !== 'redeemed' && (
          <Button variant="contained" onClick={onMarkAsRedeemed}>Mark As Redeemed</Button>
        )
      }
      <Dialog 
        onSubmit={handleClose}
        key="confirmation"
        open={openConfirmation}
        title="Confirmation"
        content={successMessage}
        children={formButtons}
        onClose={handleClose}
      />
    </>
  );
};

export default MarkCodeAsRedeemed;